var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhsDiscoverabilityInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.351562 8.92969V40.2539C0.351562 41.7656 1.54687 42.9609 3.05859 42.9609H41.9414C43.418 42.9609 44.6484 41.7305 44.6484 40.2539V8.92969H0.351562Z",
    fill: "#A6E1FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55078 22.3242H26.7539V39.832H3.55078V22.3242Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.082 22.3594H26.7539V39.8672H24.082V22.3594Z",
    fill: "#EDEDED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4492 13.6406V18.0703C41.4492 18.668 40.957 19.1602 40.3594 19.1602H4.64062C4.04297 19.1602 3.55078 18.668 3.55078 18.0703V13.6406C3.55078 13.043 4.04297 12.5508 4.64062 12.5508H40.3594C40.957 12.5508 41.4492 13.043 41.4492 13.6406Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.582 12.5508H4.64062C4.04297 12.5508 3.55078 13.043 3.55078 13.6406V18.0703C3.55078 18.668 4.04297 19.1602 4.64062 19.1602H10.582V12.5508Z",
    fill: "#7BDE9E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06641 19.125H4.64062C4.04297 19.125 3.55078 18.6328 3.55078 18.0352V13.6406C3.55078 13.043 4.04297 12.5508 4.64062 12.5508H7.06641C6.46875 12.5508 5.97656 13.043 5.97656 13.6406V18.0703C5.97656 18.6328 6.46875 19.125 7.06641 19.125Z",
    fill: "#A7E9BF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4492 13.6406V18.0703C41.4492 18.668 40.957 19.1602 40.3594 19.1602H37.9336C38.5312 19.1602 39.0234 18.668 39.0234 18.0703V13.6406C39.0234 13.043 38.5312 12.5508 37.9336 12.5508H40.3594C40.957 12.5508 41.4492 13.043 41.4492 13.6406Z",
    fill: "#EDEDED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6484 8.92969V40.2539C44.6484 41.7656 43.4531 42.9609 41.9414 42.9609H39.4102C40.9219 42.9609 42.1172 41.7305 42.1172 40.2539V8.92969H44.6484Z",
    fill: "#7AD1F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.351562 8.92969V40.2539C0.351562 41.7656 1.54687 42.9609 3.05859 42.9609H5.58984C4.07812 42.9609 2.88281 41.7305 2.88281 40.2539V8.92969H0.351562Z",
    fill: "#D3F0FD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6484 8.92969V4.71094C44.6484 3.19922 43.418 2.00391 41.9414 2.00391H3.05859C1.58203 2.00391 0.351562 3.23438 0.351562 4.71094V8.92969H44.6484Z",
    fill: "#D3D9D9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58984 2.00391C4.07812 2.00391 2.88281 3.19922 2.88281 4.71094V8.92969H0.351562V4.71094C0.351562 3.19922 1.54687 2.00391 3.05859 2.00391H5.58984Z",
    fill: "#EDEDED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6484 4.71094V8.92969H42.1172V4.71094C42.1172 3.19922 40.8867 2.00391 39.4102 2.00391H41.9414C43.4531 2.00391 44.6484 3.23438 44.6484 4.71094Z",
    fill: "#A8B2B4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46484 6.71484C5.14441 6.71484 5.69531 6.16394 5.69531 5.48438C5.69531 4.80481 5.14441 4.25391 4.46484 4.25391C3.78527 4.25391 3.23438 4.80481 3.23438 5.48438C3.23438 6.16394 3.78527 6.71484 4.46484 6.71484Z",
    fill: "#F58120"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82422 6.71484C9.50379 6.71484 10.0547 6.16394 10.0547 5.48438C10.0547 4.80481 9.50379 4.25391 8.82422 4.25391C8.14465 4.25391 7.59375 4.80481 7.59375 5.48438C7.59375 6.16394 8.14465 6.71484 8.82422 6.71484Z",
    fill: "#FEDD8E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2188 6.71484C13.8983 6.71484 14.4492 6.16394 14.4492 5.48438C14.4492 4.80481 13.8983 4.25391 13.2188 4.25391C12.5392 4.25391 11.9883 4.80481 11.9883 5.48438C11.9883 6.16394 12.5392 6.71484 13.2188 6.71484Z",
    fill: "#7BDE9E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66016 5.48438C5.66016 6.15234 5.09766 6.71484 4.42969 6.71484C3.90234 6.71484 3.44531 6.36328 3.26953 5.90625C3.41016 5.94141 3.55078 5.97656 3.69141 5.97656C4.35937 5.97656 4.92187 5.41406 4.92187 4.74609C4.92187 4.60547 4.88672 4.46484 4.85156 4.32422C5.34375 4.5 5.66016 4.95703 5.66016 5.48438Z",
    fill: "#F58120"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0547 5.48438C10.0547 6.15234 9.49219 6.71484 8.82422 6.71484C8.29688 6.71484 7.83984 6.36328 7.66406 5.90625C7.80469 5.94141 7.94531 5.97656 8.08594 5.97656C8.75391 5.97656 9.31641 5.41406 9.31641 4.74609C9.31641 4.60547 9.28125 4.46484 9.24609 4.32422C9.70312 4.5 10.0547 4.95703 10.0547 5.48438Z",
    fill: "#FDD267"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4492 5.48438C14.4492 6.15234 13.8867 6.71484 13.2187 6.71484C12.6914 6.71484 12.2344 6.36328 12.0586 5.90625C12.1992 5.94141 12.3398 5.97656 12.4805 5.97656C13.1484 5.97656 13.7109 5.41406 13.7109 4.74609C13.7109 4.60547 13.6758 4.46484 13.6406 4.32422C14.0977 4.5 14.4492 4.95703 14.4492 5.48438Z",
    fill: "#50D27E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7656 5.48438C41.7656 6.15234 41.2031 6.71484 40.5352 6.71484H20.1797C19.5117 6.71484 18.9492 6.15234 18.9492 5.48438C18.9492 4.81641 19.5117 4.25391 20.1797 4.25391H40.5352C41.2383 4.25391 41.7656 4.78125 41.7656 5.48438Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7656 5.48438C41.7656 6.15234 41.2031 6.71484 40.5352 6.71484H20.1797C19.5117 6.71484 18.9844 6.1875 18.9492 5.55469C19.125 5.66016 19.3359 5.69531 19.5469 5.69531H39.9023C40.5703 5.69531 41.1328 5.13281 41.1328 4.46484V4.42969C41.5195 4.60547 41.7656 4.99219 41.7656 5.48438Z",
    fill: "#EDEDED"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69922 14.6602C8.19141 15.1523 8.19141 15.9609 7.69922 16.4883C7.20703 16.9805 6.39844 16.9805 5.87109 16.4883C5.37891 15.9961 5.37891 15.1875 5.87109 14.6602C6.39844 14.168 7.20703 14.168 7.69922 14.6602Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.082 35.7539L22.7109 37.1953L19.4063 33.9961L18.1406 36.6328L15.9258 29.2852L23.3438 31.2188L20.7773 32.5898L24.082 35.7539Z",
    fill: "#F58120"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.082 35.7539L22.7109 37.1953L21.5156 36.0352L22.8867 34.5938L24.082 35.7539Z",
    fill: "#F58120"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2539 31.8164L17.0859 30.4453L18.6328 35.6133L18.1406 36.6328L15.9258 29.2852L23.3438 31.2188L22.2539 31.8164Z",
    fill: "#F58120"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9531 22.3242H41.4141V29.4961H29.9531V22.3242Z",
    fill: "#FEDD8E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7773 22.3242H41.4492V29.4961H38.7773V22.3242Z",
    fill: "#FDD367"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9531 22.3242H32.625V29.4961H29.9531V22.3242Z",
    fill: "#FEE9B4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9531 32.6953H41.4141V39.8672H29.9531V32.6953Z",
    fill: "#FEDD8E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7773 32.6953H41.4492V39.8672H38.7773V32.6953Z",
    fill: "#FDD367"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9531 32.6953H32.625V39.8672H29.9531V32.6953Z",
    fill: "#FEE9B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhsDiscoverabilityInfo);
export default __webpack_public_path__ + "static/media/WHSDiscoverabilityInfo.e80fc8729bd7b62984a5285290f4fb94.svg";
export { ForwardRef as ReactComponent };